import type React from "react";
import styled from "styled-components";
import { radius } from "@libertify/ui";

export const DSection = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #f3f4f6;
`;

export const DSectionLabel = styled.span`
  font-size: 11px;
  color: #9ca3af;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  display: block;
`;

export const TitleEditRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleText = styled.span`
  font-size: 14px;
  color: #090e19;
  flex: 1;
  line-height: 1.5;
`;

export const DSaveBtn = styled.button`
  background: #14b8a6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 4px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
`;

export const AudienceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  & + & {
    border-top: 1px solid #f9fafb;
  }
`;

export const AudienceRowLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
`;

export const LinkItemRow = styled.div`
  border: 1px solid #f3f4f6;
  border-radius: ${radius.box}px;
  padding: 10px 12px;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LinkItemLabel = styled.span`
  flex: 1;
  font-size: 13px;
  color: #374151;
`;

export const AddLinkForm = styled.div`
  margin-top: 8px;

  @keyframes fadeInForm {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  animation: fadeInForm 0.2s ease both;
`;

export const AddLinkFormRow = styled.div`
  display: flex;
  gap: 6px;
  margin-bottom: 8px;
  align-items: center;
`;

export const AddLinkFormActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const ConfirmLinkBtn = styled.button`
  background: #14b8a6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 5px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;

  &:disabled {
    background: #d1d5db;
    cursor: not-allowed;
  }
`;

export const CancelLinkBtn = styled.button`
  background: transparent;
  color: #6b7280;
  border: none;
  padding: 5px 8px;
  font-size: 13px;
  cursor: pointer;
`;

export const StatGridD = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 12px;
`;

export const StatCardD = styled.div`
  background: #f9fafb;
  border: 1px solid #f3f4f6;
  border-radius: ${radius.box}px;
  padding: 12px 14px;
`;

export const StatNumberD = styled.div`
  font-size: 22px;
  font-weight: 800;
  color: #090e19;
  line-height: 1.1;
`;

export const StatLabelD = styled.div`
  font-size: 11px;
  color: #9ca3af;
  font-weight: 500;
  margin-top: 2px;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const AnalyticsLinkD = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: #14b8a6;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.15s;

  &:hover {
    color: #0d9488;
  }
`;

export const ChatHistoryRowD = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ChatHistoryLeftD = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #374151;
`;

export const ViewHistoryLinkD = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 12.5px;
  color: #14b8a6;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.15s;

  &:hover {
    color: #0d9488;
  }
`;

export const DocPillD = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: #f0fdfb;
  border: 1px solid #ccfbf1;
  border-radius: 8px;
  padding: 7px 12px;
  margin-bottom: 10px;
  width: 100%;
`;

export const DocPillTextD = styled.span`
  font-size: 12.5px;
  color: #0d9488;
  font-weight: 500;
  flex: 1;
`;

export const PrimaryBadgeD = styled.span`
  background: #ccfbf1;
  color: #0d9488;
  border-radius: ${radius.pill}px;
  padding: 2px 8px;
  font-size: 10px;
  font-weight: 600;
  margin-left: auto;
  flex-shrink: 0;
`;

export const AddDocBtnD = styled.button`
  width: 100%;
  border: 1.5px dashed #d1d5db;
  border-radius: ${radius.box}px;
  padding: 11px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  cursor: pointer;
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
  transition:
    border-color 0.15s,
    color 0.15s;

  &:hover {
    border-color: #9ca3af;
    color: #374151;
  }
`;

export const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ShareFooterBtn = styled.button`
  width: 100%;
  height: 44px;
  background: #14b8a6;
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background: #0d9488;
  }
`;

export const ExportFooterBtn = styled.button`
  width: 100%;
  height: 40px;
  background: transparent;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
  transition:
    border-color 0.15s ease,
    background 0.15s ease,
    color 0.15s ease;

  &:hover {
    background: #f3f4f6;
    border-color: #9ca3af;
    color: #111827;
  }

  &:disabled {
    color: #b8bcc5;
    border-color: #e5e7eb;
    cursor: not-allowed;
    opacity: 0.6;
  }

  &:disabled:hover {
    background: transparent;
    border-color: #e5e7eb;
    color: #b8bcc5;
  }
`;

export const EditIconBtn = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
`;

export const TrashBtn = styled.button`
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
`;

export const TEAL_SWITCH_STYLE = {
  "--ant-color-primary": "#14B8A6",
} as React.CSSProperties;
